import axios, { CancelTokenSource } from "axios";

import { ListCompanyFilterInterface, GetCompanyResponseInterface } from "@/components/TagSelect/TagSelect";
import { get } from "@/utils/valetSellerSApiClient.utils";

// Define a cancel token source globally
let cancelCompanyTokenSource: CancelTokenSource | undefined;

// Function to cancel the ongoing request
export const cancelPreviousOrderRequest = (
  reason: string = "Request canceled for the new one",
) => {
  if (cancelCompanyTokenSource) {
    cancelCompanyTokenSource.cancel(reason);
  }
};

export const listBrands = (data: ListCompanyFilterInterface) => {
  // Cancel the previous request if it exists
  cancelPreviousOrderRequest();

  // Create a new cancel token source
  cancelCompanyTokenSource = axios.CancelToken.source(); // eslint-disable-next-line import/no-named-as-default-member
  return get<GetCompanyResponseInterface>(
    "/company",
    { ...data },
    { cancelToken: cancelCompanyTokenSource.token },
  );
};
